module.exports = __webpack_public_path__ + "static/media/USflag.dab7c5ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/USflag.png
// module id = 613
// module chunks = 0